var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 11.6504V15.7227C16.3281 16.0457 16.0653 16.3086 15.7422 16.3086H4.25781C3.93473 16.3086 3.67188 16.0457 3.67188 15.7227V11.6504H2.5V15.7227C2.5 16.6919 3.28855 17.4805 4.25781 17.4805H15.7422C16.7114 17.4805 17.5 16.6919 17.5 15.7227V11.6504H16.3281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5L6.35889 6.14113L7.18752 6.96976L9.41408 4.7432V13.8755H10.586V4.7432L12.8125 6.96976L13.6412 6.14113L10 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.e8a575bb799c1a9d42609cb031b089d6.svg";
export { ForwardRef as ReactComponent };